import { UploadsDataGridWithQuery } from "../../components/UploadsDataGrid/UploadsDataGridWithQuery";

const UploadBrowser = () => {
  return <UploadsDataGridWithQuery />;
};

export { UploadBrowser };
